adminApp.component('loggerConfig', {
    templateUrl: '/public/components/logger-config.component.html',
    bindings: {

    },

    controller: function($scope) {
        const ctrl = this;
        const mainProcess = "WebServer";

        ctrl.loggers = [];
        ctrl.logLevels = [];
        ctrl.processes = [];
        ctrl.loggerToAdd = {};
        ctrl.selectedProcess = {};
        ctrl.loading = true;

        ctrl.$onInit = () => {

           store.fetch({
                path: '/catoadmin/components',
                success: (data) => {
                    if(data != null) {
                        let receivedServiceNames = [];
                        for (let [key, value] of Object.entries(data)) {
                          receivedServiceNames.push(...(value.map(v => v.name)))
                        }
                        ctrl.processes = receivedServiceNames;
                        ctrl.selectedProcess = mainProcess;
                        ctrl.selectTab();
                    }
                },
           });

        }

        ctrl.changeLogLevel = (logger) => {
           store.action({
               path: 'catoadmin/setLoggerLevel',
               dataObj: 'json',
               queryParams: {process: ctrl.selectedProcess},
               data: {
                   name: logger.name,
                   level: logger.newLevel,
               },
               success: (data) => {
                  if(data.status && data.status === 'ERROR') {
                     $scope.$root.handleServerResponse(data);
                  } else {
                      updateLogger(data);
                  }
               },
               error: (data) => {
               }
           });
        }

        ctrl.addNew = () => {
           ctrl.changeLogLevel(ctrl.loggerToAdd);
        }

        ctrl.selectTab = () => {
            ctrl.loading = true;
            fetchProcessLoggerConfig();
        }

        function fetchProcessLoggerConfig() {
           store.fetch({
               path: 'catoadmin/getLoggers',
               queryParams: {process: ctrl.selectedProcess},
               success: (data) => {
                    if(data.status && data.status === 'ERROR') {
                       $scope.$root.handleServerResponse(data);
                       ctrl.loggers = [];
                    } else {
                       ctrl.loggers = data;
                    }
                    ctrl.loading = false;
               },
               error: (data) => {
               }
           });

           store.fetch({
               path: 'catoadmin/getAvailableLogLevels',
               queryParams: {process: ctrl.selectedProcess},
               success: (data) => {
                   ctrl.logLevels = data;
               },
               error: (data) => {
               }
           });
        }

        function updateLogger(logger) {
           for (let log of ctrl.loggers) {
               if(log.name === logger.name) {
                   log.level = logger.level;
                   return;
               }
           }
           ctrl.loggers.push(logger);
        }

    }

});
